<template>
    <div class="mt-7">
      <div class="d-flex justify-content-center my-5">
        <h1 class="center title">{{ !showUpdateForm ? 'Users' : 'Edite user' }}</h1>
      </div>
      <div class="container d-flex justify-content-around mb-5">
        <button type="button" class="btn btn-add" v-on:click="AddAction">Add new user</button>
      </div>

      <!-- <p>{{ $store.state.showListOfCard }}</p> -->

      <div v-if="!showAddForm && !showUpdateForm" class=" container d-flex justify-content-between flex-wrap" >
        <BlogCard :key="index" v-for=" (blog , index) in this.blogs " :blog=blog  @update="updateAction"  @refresh="getData" />
      </div>
      <AddBlog v-if="showAddForm" @toggle="AddAction" @refresh="getData" />
      <UpdateBlog v-if="showUpdateForm"  :blog="this.toUpdate" @toggle="AddAction2" @cancel="updateAction" @refresh="getData" />
    </div>
</template>

<script>
import BlogCard from "./components/Users/Users.vue";
import AddBlog from "./components/Users/AddUser.vue";
import UpdateBlog from "./components/Users/UpdateUser.vue";
import APIs from './../../config'
import axios from "axios";
export default {
    name: "Blog",
    data() {
        return {
            blogs: [] , 
            showAddForm : false, 
            showAddNewUserForm : false,
            showUpdateForm : false,
            toUpdate : {}
        };
    },
    created(){
      this.getData()
    },
    watch: {
      '$store.state.showListOfCard': function() {
            this.showAddForm = false,
            this.showAddNewUserForm = false
            this.showUpdateForm = false

            console.log("value watching ... from user")

            this.getData()
      }
    },
    components: { BlogCard, AddBlog, UpdateBlog } , 
    methods : {
        getData() {
          var get_token = localStorage.getItem('token')
          var user_id = localStorage.getItem('user_id')

          axios.get(`${APIs.API_URL}/superAdmin/adminList/${user_id}`,{
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${get_token}`
              }
          })
          .then(res => {
              this.blogs = res.data
          }).catch(error => {
              console.error(error)
          })
          this.showAddForm = this.showUpdateForm = false
        },
        AddAction(){
            this.showAddForm = !this.showAddForm
            if(this.showUpdateForm)
                this.showUpdateForm = !this.showUpdateForm
        },
        AddAction2(){
            this.showAddForm = false,
            this.showAddNewUserForm = false
            this.showUpdateForm = false
        },
        updateAction(blog){
          this.showUpdateForm = !this.showUpdateForm
          this.toUpdate = blog
        },
    }
}
</script>

<style scoped lang="scss">
  .btn-add {
    z-index: 2 !important;
  }
  .title {
    z-index: 2;
  }
</style>